import React from 'react';
import { connect } from 'react-redux';
import { getUserAuthProfile } from 'web/store/modules/user';
import {
  setTransformPseudo,
  setTransformTranslationId,
  setTransformTranslationText,
  isBlogEnabled,
  getTranslationTransform,
} from 'web/store/modules/site';
import { getId, getPageFacilityId } from 'web/store/modules/pageBuilder';
import { getWebDomain } from '../../../../modules/domain';
import useQuery from '../../../../modules/react/hooks/useQuery';
import fetch from 'unfetch';
import { getPath } from '../../../web/store/modules/page';
import AdminControls from '../components/AdminControls';
import gql from 'graphql-tag';

const GET_SITES = gql`
  query Sites {
    sites {
      primaryHostname {
        ssl
      }
      ...AdminControlsSites
    }
    currentSite {
      ...AdminControlsSites
    }
  }

  ${AdminControls.fragments.sites}
`;

const requestChangeSite = id => fetch(`/change-site/${id}`, {
  method: 'POST',
});

const getChangeSiteHandler = ({ id, identifier, primaryHostname }) => {
  const { location: { host } } = window;

  if (host.startsWith('localhost')) {
    return async () => {
      await requestChangeSite(id);
      window.location.reload(true);
    };
  }

  return getWebDomain(host, { identifier, primaryHostname }, 'admin');
};

const AdminControlsContainer = (props) => {
  const { data } = useQuery(GET_SITES);
  const siteHandlers = data?.sites.map(
    ({ id, identifier, primaryHostname }) => ({
      identifier,
      hostname: primaryHostname?.hostname,
      handler: getChangeSiteHandler({ id, identifier, primaryHostname }),
    }),
  );

  return <AdminControls {...props} siteHandlers={siteHandlers} currentSite={data?.currentSite} />;
};
const mapStateToProps = (state) => {
  const id = getId(state);
  const facilityId = getPageFacilityId(state);

  return {
    user: getUserAuthProfile(state),
    translationTransform: getTranslationTransform(state),
    pageId: id,
    facilityId,
    blogEnabled: isBlogEnabled(state),
    pathname: getPath(state),
  };
};

const mapDispatchToProps = {
  setTransformPseudo,
  setTransformTranslationId,
  setTransformTranslationText,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminControlsContainer);
